import { getCard, type CardId } from '../game/content/cards';
import type { SessionState } from '../game/simulation/types';

/** Labels explain the simulation's availability without changing its rules. */
export function cardPresentation(state: SessionState, cardId: CardId, enabled: boolean, reason: string | null | undefined, auto: boolean) {
  const card = getCard(cardId);
  const badge = enabled ? '使用可能' : auto ? '自動操作中'
    : reason === '布石が足りません' ? `布石が${card.cost - state.card.stones}不足`
    : reason === '対象のキャラがいません' ? '対象なし'
    : reason === '同じキャラです' ? '同じ石'
    : reason === 'すでに効果中です' ? '効果中'
    : state.status === 'paused' ? '一時停止中' : '使用不可';
  const detail = enabled ? 'カードを押して使う' : auto ? 'カードの使用は自動で判断します'
    : reason === '布石が足りません' ? '同じ石を合体させると、布石 +1'
    : reason === '対象のキャラがいません'
      ? ((cardId === 'destroy' || cardId === 'buoyancy' || cardId === 'attraction') && !state.dropView.lastPlacedEntityId
        ? '直前に置いた石が盤面に残っていると使えます' : '位置を調整できる石があると使えます')
      : reason === '同じキャラです' ? '入れ替える2つの石が同じです'
      : reason ?? 'ゲーム中に使えます';
  return { badge, detail };
}
